import React from 'react'
import { Redirect } from 'react-router-dom'

// import dashboardRoutes from './views/dashboard/OldDashboardRoutes'
import AptituteRoutes from './views/AptituteTest/AptituteRoutes'
import AddNewOrgRoutes from './views/Organization/OrganizationRoutes'
import PortalRoutes from './views/Portals/PortalRoutes'
import UserRoutes from './views/User/UserRoutes'
import ConfigRoutes from './views/Configurations/ConfigRoutes'
import ExpenseRoutes from './views/ExpenseDashboards/ExpenseRoutes'
import DataDashboardRoutes from './views/DataDashboards/DataDashboardRoutes'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/user/myprofile" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [
    ...DataDashboardRoutes,
    ...AptituteRoutes,
    ...AddNewOrgRoutes,
    ...PortalRoutes,
    ...UserRoutes,
    ...ConfigRoutes,
    ...ExpenseRoutes,
    ...redirectRoute,
    ...errorRoute,
]

export default routes
